import { render, staticRenderFns } from "./TwProcessGroupListEdit.vue?vue&type=template&id=4678155c&scoped=true&"
import script from "./TwProcessGroupListEdit.vue?vue&type=script&lang=js&"
export * from "./TwProcessGroupListEdit.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessGroupListEdit.vue?vue&type=style&index=0&id=4678155c&lang=scss&scoped=true&"
import style1 from "./TwProcessGroupListEdit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4678155c",
  null
  
)

export default component.exports